import Cookies from 'universal-cookie';
import lodash from 'lodash';
import _ from 'lodash';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const mfeConfig = window.mfeConfig;
localStorage.setItem('mfeConfig', JSON.stringify(mfeConfig));
let moduleOverrides = null;
window.addEventListener('@gscope-mfe/devtools:content', function listener(evt) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (evt?.detail?.type === 'IMPORT_MAP_OVERRIDES') {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        moduleOverrides = evt?.detail?.data;
        window.removeEventListener('@gscope-mfe/devtools:content', listener);
    }
});
const cookies = new Cookies();
const WIRE_COOKIES = [
    { key: 'authToken', stringify: true },
    { key: 'authHeader', stringify: false },
    { key: 'loggedInUserName', stringify: true },
    { key: 'auth-src', stringify: false },
    { key: 'wire-id', stringify: true },
    { key: 'store-no', stringify: false },
    { key: 'loggedIn', stringify: false },
    { key: 'loggedInDomain', stringify: false },
    { key: 'currentMarket', stringify: false },
    { key: 'market', stringify: false },
    { key: 'Division', stringify: true },
    { key: 'Department', stringify: true },
    { key: 'wm-SystemJobcodes', stringify: true },
    { key: 'FullTimePartTimeCode', stringify: true },
    { key: 'wm-SystemJobcodes', stringify: true },
    { key: 'wm-TypeEmployeeType', stringify: true },
    { key: 'WIN', stringify: true },
    { key: 'loginId', stringify: true },
];

const GscopeMfeTools = Object.freeze({
    getMfeConfig() {
        return mfeConfig;
    },
    getModuleOverrides() {
        return moduleOverrides;
    },
    getInfra() {
        const mfeConfig = this.getMfeConfig();
        const [, infra = 'gscope'] = mfeConfig.APP_ENV.split(':').reverse();
        return infra;
    },
    isStrideInfra() {
        return this.getInfra() === 'stride';
    },
    getWireCookies() {
        return {
            ..._.pick(
                cookies.getAll({ doNotParse: true }),
                WIRE_COOKIES.map((wc) => wc.key),
            ),
            loggedInDomain: 'store',
        };
    },
    setWireCookies(wireCookies) {
        WIRE_COOKIES.forEach((wc) => {
            cookies.set(
                wc.key,
                wc.stringify
                    ? wireCookies[wc.key].startsWith('"')
                        ? wireCookies[wc.key]
                        : JSON.stringify(wireCookies[wc.key])
                    : wireCookies[wc.key],
                {
                    encode: (x) => x,
                },
            );
        });
    },
});

if (!window.GscopeMfeTools) {
    Object.defineProperty(window, 'GscopeMfeTools', {
        value: GscopeMfeTools,
        writable: false,
    });
}
export default GscopeMfeTools;

Object.defineProperty(window, '__IS_GSCOPE_MFE__', {
    value: true,
    writable: false,
});
if (window?.__GSCOPE_MFE_DEVTOOLS__?.activate) {
    window.__GSCOPE_MFE_DEVTOOLS__.activate(mfeConfig);
}
